import { dataURLtoFile } from "./../../../../helpers";
import store from "../../../store";

export default function useCropper() {

    function uploadCropperFile(type, file) {
        const dispatchMethod = 'cropper/UPLOAD_FILE'
        const files = dataURLtoFile(file, 'file.jpg')

        return store.dispatch(dispatchMethod, { type, files })
            .then(({ data }) => {
                const product = store.getters['product/getProduct']

                product.files[type] = data

                store.commit('product/SET_PRODUCT', product)
            })
    }

    function compressImage(canvas) {
        return canvas.toDataURL('image/jpeg', 0.75)
    }

    return {
        uploadCropperFile,
        compressImage,
    }
}
